// extracted by mini-css-extract-plugin
module.exports = {"macroQuote":"MacroQuote_macroQuote__h_sy8"};